import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import { timingsReviewerIsShemsiUser } from "src/config/reviewSystemData";
import classNames from "src/helpers/classNames";
import updateOptionsSelected from "src/helpers/updateOptionsSelected";

interface TimeAsShemsiUserFormProps {
  timeAsShemsiUser: string;
  setTimeAsShemsiUser: Dispatch<SetStateAction<string>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
  isFormSubmittedOnce: boolean;
}

const TimeAsShemsiUserForm = ({
  timeAsShemsiUser,
  setTimeAsShemsiUser,
  setReviewStep,
  isFormSubmittedOnce,
}: TimeAsShemsiUserFormProps) => {
  const t = useTranslations("ReviewForm");
  return (
    <>
      <section className="m-auto flex flex-col items-center gap-10">
        <h2 className="text-center text-2xl font-semibold">
          {t("how_long_have_you_been_a_shemsi_user")}
        </h2>
        <div className="flex flex-col items-center gap-4">
          {timingsReviewerIsShemsiUser.map((timing) => (
            <button
              key={timing}
              type="button"
              onClick={() => setTimeAsShemsiUser(timing)}
              className={classNames(
                "w-full border border-white p-2 hover:border-beige-800",
                timeAsShemsiUser.includes(timing) ? "!border-black" : ""
              )}
            >
              {t(timing)}
            </button>
          ))}
        </div>
      </section>
      <div className="flex self-end">
        {isFormSubmittedOnce ? (
          <ThemeButton
            onClick={() => setReviewStep(9)}
            disabled={timeAsShemsiUser === "" || !timeAsShemsiUser}
          >
            {t("preview_your_review")}
          </ThemeButton>
        ) : (
          <ThemeButton
            onClick={() => setReviewStep((prevstep) => prevstep + 1)}
            disabled={timeAsShemsiUser === "" || !timeAsShemsiUser}
          >
            {t("next")}
          </ThemeButton>
        )}
      </div>
    </>
  );
};

export default TimeAsShemsiUserForm;
